// extracted by mini-css-extract-plugin
export default {"container":"users_list_modal_container__dneHA","avatar":"users_list_modal_avatar__wKrFR"};